<template>
  <mdb-modal v-show="value" @close="closeDialog" @show="cleanFields">
    <mdb-modal-header  color="grey lighten-4" class="d-flex align-items-center justify-content-between" textColor="grey darken-4">
        <b class="ml-3 mb-0">Post-Completion Quality Assessment</b>
      </mdb-modal-header>
      <mdb-modal-body>
        <mdb-container>
          <mdb-row>
            <mdb-col>
              <star-rating v-model="ratingStars" />
            </mdb-col>
          </mdb-row>
          <mdb-row>
            <mdb-col class="w-100" style="min-height: 10rem;">
              <mdb-textarea v-model="comment" class="h-100 w-100 border-top min-h-100" label="Comment (10 words minimum if less than 5 stars)" />
            </mdb-col>
          </mdb-row>
        </mdb-container>
      </mdb-modal-body>
      <mdb-modal-footer>
          <mdb-btn color="success" type="submit" :disabled="loading || (ratingStars < 1 || (ratingStars < 5 && commentWordLength < 10))" @click="saveComment">
            <div class="spinner-border mr-1 text-light spinner-border-sm" role="status" v-if="loading">
              <span class="sr-only">Loading...</span>
            </div>
            Rate
          </mdb-btn>
        </mdb-modal-footer>
  </mdb-modal>
</template>

<script>
import Apicall from '@/libs/Apicall';
import {
  mdbBtn,
  mdbCol,
  mdbContainer,
  mdbModal,
  mdbModalBody,
  mdbModalFooter,
  mdbModalHeader,
  mdbRow,
  mdbTextarea,
} from 'mdbvue';
import StarRating from 'vue-star-rating';

export default {
  components: {
    mdbBtn,
    mdbCol,
    mdbContainer,
    mdbModal,
    mdbModalBody,
    mdbModalFooter,
    mdbModalHeader,
    mdbTextarea,
    mdbRow,
    StarRating,
  },
  computed: {
    commentWordLength() {
      return this.comment?.trim()?.split(' ').filter((word) => word.trim()).length;
    },
  },
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    taskId: {
      type: Number,
      required: true,
    },
    employeeId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      ratingStars: 0,
      comment: '',
      loading: false,
    };
  },
  methods: {
    closeDialog() {
      this.taskId = null;
      this.employeeId = null;
      this.cleanFields();
      this.$emit('input', false);
    },
    cleanFields() {
      console.log('clean fields');
      this.ratingStars = 0;
      this.comment = '';
    },
    saveComment() {
      const api = new Apicall();

      api.call('POST', 'api/review-comment', {
        ratingStars: this.ratingStars,
        employeeId: this.employeeId,
        taskId: this.taskId,
        comment: this.comment,
      }).then((response) => {
        if (response.status === 'OK') {
          this.$emit('save-rating', this.taskId);
          this.value = false;
        } else {
          this.$emit('fail-rating', response.msg);
        }
      }).catch((error) => {
        this.$emit('fail-rating', error);
      });
    },
  },
};
</script>

<style>
  textarea {
    min-height: 100%;
  }
</style>
